import React from 'react'
import Reflux from 'reflux'
import { Row, Col } from 'reactstrap'

import CurrentRecipeStore from '~/stores/currentRecipe.js'


export default class RecipeDetailsPreheat extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = CurrentRecipeStore
		this.storeKeys = ['description']
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		return (
			this.state.description !== ''
			&& this.state.description !== null
		)
			? (
				<Row>
					<Col xs={12} style={{ padding: '1em' }}>
						<strong>
							Description:
						</strong>
						{' '}
						{this.state.description}
					</Col>
				</Row>
			)
			: null
	}
}



// WEBPACK FOOTER //
// ./src/modules/details/description.jsx